import {ImageRequestParams} from "../../params/image-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../core/app/consts";

export class AnimationLogoEventRequestParams extends ImageRequestParams {
  id: Number;
  rotate: Number;

  constructor(id: Number) {
    super({resourceName: 'website/animations'});

    this.id = id;
    this._width = 32;
    this.ratio = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.AUTO;
  }

  get angle() {
    return this.rotate;
  }

  toString(): String {
    return super.toString() + '/' + this.id;
  }
}
